import { Sounds, GameState } from 'macguffin'
import { gameDelay } from 'macguffin/Utils'
import { takeEvery, select } from 'redux-saga/effects'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

import GameMode from "game/modes"
import ArrayHelper from "utils/ArrayHelper"
import { WIN_LEVELS } from "game/components/winCounter"
import { startBonus } from "game/redux/actions"
import Timeout from 'macguffin/Utils/Timeout'

import {
  SET_CURRENT_WIN_DATA,
  SET_CURRENT_WIN_ITERATION,
  REEL_STOPPING,
  REEL_STOPPED,
  START_COUNTDOWN,
  START_BONUS,
  ROCKET_TAKEOFF_COMPLETE,
  START_SPIN,
  START_RESPIN,
  START_FREESPIN,
  START_PICK_STAGE,
  PICK_ITEM,
  SET_CURRENT_PICK_RESULT_DATA,
  SET_RESPIN_SUMMARY,
  SET_FREESPIN_SUMMARY,
  SET_JACKPOT_DRAW,
  BONUS_COMPLETE,
  COMET_FLYPAST,
  START_MARS_SEQUENCE,
  PICK_LANDING_ZONE,
  WIN_COUNTUP_STEP,
  WIN_COUNTUP_LEVEL
} from "game/redux/constants"

import soundMix from './mix.json'

export function getRandomSound(keys) {
  const index = Math.floor(Math.random() * keys.length)
  return keys[index]
}

const { put } = GameState.SagaEffects

const {
  PLAY_REQUEST,
  UPDATE_BET,
  ERROR,
  SHOW_MESSAGE,
  TOGGLE_SETTINGS_OPEN,
  SET_SETTINGSSCREEN,

  //types
  SETTINGSCREENS,
  MESSAGE_TYPES,
} = GameState.Constants

//music keys
const MUSIC_MAIN = "music_main"
const MUSIC_RESPIN = "music_respin"
const MUSIC_FREESPIN = "music_freespin"
const MUSIC_PICK_MODE = "music_pick_mode"
const MUSIC_LAST_CHANCE_1 = "music_last_chance_1"
const MUSIC_LAST_CHANCE_2 = "music_last_chance_2"
const MUSIC_MARS = "music_mars"

const ALL_MUSIC = [
  MUSIC_MAIN,
  MUSIC_RESPIN,
  MUSIC_FREESPIN,
  MUSIC_PICK_MODE,
  MUSIC_LAST_CHANCE_1,
  MUSIC_LAST_CHANCE_2,
  MUSIC_MARS,
]

//sfx keys
const SFX_LAST_CHANCE_RESPINS_1 = "sfx_last_chance_respins_1"
const SFX_LAST_CHANCE_RESPINS_2 = "sfx_last_chance_respins_2"
const SFX_LC_COUNTDOWN = "sfx_lc_countdown"
const SFX_LC_IGNITION_START = "sfx_lc_ignition_start"
const SFX_LC_LIFTOFF = "sfx_lc_liftoff"
const SFX_LC_TMINUS = "sfx_lc_tminus"
const SFX_MARS_METER_1 = "sfx_mars_meter_1"
const SFX_MARS_METER_2 = "sfx_mars_meter_2"
const SFX_MARS_METER_3 = "sfx_mars_meter_3"
const SFX_MARS_METER_4 = "sfx_mars_meter_4"
const SFX_MARS_METER_5 = "sfx_mars_meter_5"
const SFX_MARS_METER_LOOP = "sfx_mars_meter_loop"
const SFX_COMET_CHANGE_REEL = "sfx_meteor_change_reel"
const SFX_COMET_DIES = "sfx_meteor_dies"
const SFX_COMET_LAND = "sfx_meteor_land"
const SFX_COMET_LOOP = "sfx_meteor_loop"
const SFX_COMET_PASSING_1 = "sfx_meteor_passing_1"
const SFX_COMET_PASSING_2 = "sfx_meteor_passing_2"
const SFX_COMET_PASSING_3 = "sfx_meteor_passing_3"
const SFX_COMET_PASSING_4 = "sfx_meteor_passing_4"
const SFX_PICK_STAGE_SELECTION = "sfx_pick_stage_make_selection"
const SFX_PICK_STAGE_REVEAL = "sfx_pick_stage_reveal"
const SFX_PICK_STAGE_START = "sfx_pick_stage_start"
const SFX_REEL_LOOP = "sfx_reel_loop"
const SFX_REEL_STOP = "sfx_reel_stop"
const SFX_RESPIN_START = "sfx_respin_start"
const SFX_ROCKET_LAUNCH = "sfx_rocket_launch"
const SFX_ROCKET_LOOP = "sfx_rocket_loop"
const SFX_ROCKET_PREPARE_LOOP = "sfx_rocket_prepare_loop"
const SFX_ROCKET_PREPARE = "sfx_rocket_prepare"
const SFX_ROCKET_STAGE_SEPARATE = "sfx_rocket_stage_separate"
const SFX_SPIN_BUTTON = "sfx_spin_button"
const SFX_UI_ALERT = "sfx_ui_alert"
const SFX_UI_MENU_CLOSE = "sfx_ui_menu_close"
const SFX_UI_MENU_OPEN = "sfx_ui_menu_open"
const SFX_UI_MENU_SWITCH_TAB = "sfx_ui_menu_switch_tab"
const SFX_UI_OFF_DECREMENT = "sfx_ui_off_decrement"
const SFX_UI_ON_INCREMENT = "sfx_ui_on_increment"
const SFX_UI_REALITY_CHECK = "sfx_ui_reality_check"
const SFX_WIN_COUNTUP = "sfx_win_countup"
const SFX_WIN_LEVEL_1 = "sfx_win_level_1"
const SFX_WIN_LEVEL_2 = "sfx_win_level_2"
const SFX_WIN_LEVEL_3 = "sfx_win_level_3"
const SFX_WIN_LEVEL_4 = "sfx_win_level_4"
const SFX_WIN_VALUE_HIGH = "sfx_win_value_high"
const SFX_WIN_VALUE_LOW = "sfx_win_value_low"

/*
    The base state updates before we get the actions, so when we compare them they are the same.
    This way, we can keep track of which properties change just for sound purposes.
*/
let previousMusic = null
let previousSettingsScreen = null
let previousBet = 0
let previousFreespins
let freespinScatters = 0

function changeMusic(key, duration = 2000, mix = 1) {
  if (previousMusic === key) { return }

  // Fade out all other music
  ALL_MUSIC.forEach(track => {
    if (track !== key) {
      Sounds.fadeOut(track, duration)
    }
  })

  previousMusic = key
  Sounds.fadeIn(key, duration, mix)
}

export default function* listenForSoundEvents() {
  yield initSound()

  yield takeEvery(PLAY_REQUEST, onPlayRequest)
  yield takeEvery(UPDATE_BET, onUpdateBet)
  yield takeEvery(ERROR, onError)
  yield takeEvery(SHOW_MESSAGE, onShowMessage)
  yield takeEvery(TOGGLE_SETTINGS_OPEN, onToggleSettingsOpen)
  yield takeEvery(SET_SETTINGSSCREEN, onSetSettingsScreen)

  yield takeEvery(SET_CURRENT_WIN_DATA, onSetCurrentWinData)

  yield takeEvery(WIN_COUNTUP_STEP, onWinCountUpStep)
  yield takeEvery(WIN_COUNTUP_LEVEL, onWinCountUpLevel)

  yield takeEvery(SET_CURRENT_WIN_ITERATION, onSetCurrentWinIteration)
  yield takeEvery(REEL_STOPPING, onReelStopping)
  yield takeEvery(REEL_STOPPED, onReelStopped)
  yield takeEvery(COMET_FLYPAST, onCometFlypast)
  yield takeEvery(SET_RESPIN_SUMMARY, onSetRespinSummary)

  yield takeEvery(START_COUNTDOWN, onStartCountdown)
  yield takeEvery(START_BONUS, onStartBonus)
  yield takeEvery(ROCKET_TAKEOFF_COMPLETE, onRocketTakeoffComplete)
  yield takeEvery(START_SPIN, onStartSpin)
  yield takeEvery(START_RESPIN, onStartRespin)
  yield takeEvery(START_FREESPIN, onStartFreespin)
  yield takeEvery(START_PICK_STAGE, onStartPickStage)
  yield takeEvery(PICK_ITEM, onPickItem)
  yield takeEvery(SET_CURRENT_PICK_RESULT_DATA, onSetCurrentPickResultData)
  yield takeEvery(START_MARS_SEQUENCE, onStartMarsSequence)
  yield takeEvery(PICK_LANDING_ZONE, onPickLandingZone)
  yield takeEvery(SET_JACKPOT_DRAW, onJackpotDraw)
  yield takeEvery(BONUS_COMPLETE, onBonusComplete)
}


function* initSound() {
  const { game } = yield select(state => state)
  const { currentGameMode } = game

  //  Set all volumes from json mix file
  Object.entries(soundMix).forEach((entry) => {
    Sounds.setVolume(entry[0], entry[1])
  })

  // Start music silent
  ALL_MUSIC.forEach(key => {
    Sounds.loopSound(key, true, true)
  })

  switch (currentGameMode) {
    case GameMode.RESPIN:
      changeMusic(MUSIC_RESPIN, 2000, soundMix.music_respin)
      break
    case GameMode.PICK:
      changeMusic(MUSIC_PICK_MODE, 2000, soundMix.music_pick_mode)
      break
    case GameMode.FREESPIN:
      changeMusic(MUSIC_FREESPIN, 2000, soundMix.music_freespin)
      break
    case GameMode.MAIN:
    default:
      changeMusic(MUSIC_MAIN, 2000, soundMix.music_main)
  }
}

function onPlayRequest() {
  endMarsAnticipation()
  Sounds.playSound(SFX_SPIN_BUTTON, soundMix.SFX_SPIN_BUTTON)
}

function onUpdateBet(action) {
  const { bet, change } = action

  if (change === 1 || bet > previousBet) {
    Sounds.playSound(SFX_UI_ON_INCREMENT, soundMix.SFX_UI_ON_INCREMENT)
  } else if (change === -1 || bet < previousBet) {
    Sounds.playSound(SFX_UI_ON_INCREMENT, soundMix.SFX_UI_ON_INCREMENT)
  }

  previousBet = bet
}

function onError(action) {
  Sounds.playSound(SFX_UI_ALERT, soundMix.SFX_UI_ALERT)
  gameDelay(1000)
  Sounds.stopSound(SFX_REEL_LOOP, soundMix.SFX_REEL_LOOP)
}

function onShowMessage(action) {
  const { message } = action

  if (message) {

    if (message.type === MESSAGE_TYPES.REALITYCHECK) {
      Sounds.playSound(SFX_UI_REALITY_CHECK, soundMix.SFX_UI_REALITY_CHECK)
    } else {
      Sounds.playSound(SFX_UI_ALERT, soundMix.SFX_UI_ALERT)
    }
  }
}

function onToggleSettingsOpen() {
  Sounds.playSound(SFX_UI_MENU_OPEN, soundMix.SFX_UI_MENU_OPEN)
}

function onSetSettingsScreen(action) {
  const { screen } = action

  if (previousSettingsScreen) {
    if (screen) {
      Sounds.playSound(SFX_UI_MENU_SWITCH_TAB, soundMix.SFX_UI_MENU_SWITCH_TAB)
    } else {
      Sounds.playSound(SFX_UI_MENU_CLOSE, soundMix.SFX_UI_MENU_CLOSE)
    }
  } else if (screen === SETTINGSCREENS.AUTOPLAY) {
    Sounds.playSound(SFX_UI_MENU_OPEN, soundMix.SFX_UI_MENU_OPEN)
  }

  previousSettingsScreen = screen
}

function* onReelStopping(action) {
  const { game } = yield select(state => state)
  const { currentSpinData } = game
  const { symbols } = currentSpinData

  const { reelStoppingIndex } = action

  if (reelStoppingIndex === 4) {
    Sounds.stopSound(SFX_REEL_LOOP, soundMix.SFX_REEL_LOOP)
  }

  Sounds.playSound(SFX_REEL_STOP, soundMix.SFX_REEL_STOP)

  if (symbols[reelStoppingIndex].find((symbol) => { return symbol === "WR" })) {
    yield onCometLanded()
  }
}

function* onReelStopped(action) {
  const { game } = yield select(state => state)
  const { currentSpinData, currentGameMode } = game
  const { symbols } = currentSpinData

  const { reelStoppedIndex } = action

  const reel = symbols[reelStoppedIndex]

  if (currentGameMode !== GameMode.FREESPIN) {
    if (reel.find((symbol) => { return symbol === "WR" })) {
      yield onCometChangeReel()
    }
  }

  if (reel.find((symbol) => { return symbol === "SC" })) {
    yield onCollectScatterSymbol()
  }
}

function* onCometLanded() {
  const { game: { currentRespinIndex, currentGameMode } } = yield select(state => state)

  if (currentGameMode === GameMode.FREESPIN) {
    return
  }

  Sounds.playSound(SFX_COMET_LAND, soundMix.SFX_COMET_LAND)
  Sounds.loopSound(SFX_COMET_LOOP, soundMix.SFX_COMET_LOOP)

  if ((isNaN(currentRespinIndex) || currentRespinIndex < 0)) {
    Sounds.playSound(SFX_RESPIN_START, soundMix.SFX_RESPIN_START)
    changeMusic(MUSIC_RESPIN, 2000, soundMix.music_respin)
  }
}

function* onCometChangeReel() {
  const { game } = yield select(state => state)
  const { currentGameMode } = game

  if (currentGameMode === GameMode.FREESPIN) {
    return
  }

  Sounds.playSound(SFX_COMET_CHANGE_REEL, soundMix.SFX_COMET_CHANGE_REEL)
}

function* onSetCurrentWinData(action) {
  const { session } = yield select(state => state)
  const { betAmount } = session
  const { winTotal } = action

  const nextWinLevelIndex = WIN_LEVELS.findIndex((level) => {
    return (level.multiplier * betAmount) > winTotal
  })

  const currentWinLevelIndex = Math.max(nextWinLevelIndex - 1, 0)

  const winLevelSounds = [
    SFX_WIN_LEVEL_1,
    SFX_WIN_LEVEL_2,
    SFX_WIN_LEVEL_3,
    SFX_WIN_LEVEL_4
  ]

  const soundKey = (currentWinLevelIndex < 4) ? winLevelSounds[currentWinLevelIndex] : ArrayHelper(winLevelSounds).last()
  Sounds.playSound(soundKey, soundMix.soundKey)

}

function onWinCountUpStep() {
  Sounds.playSound(SFX_WIN_COUNTUP, soundMix.SFX_WIN_COUNTUP)
}

function onWinCountUpLevel(action) {
  const { level = 0 } = action

  const winLevelSounds = [
    SFX_WIN_LEVEL_1,
    SFX_WIN_LEVEL_2,
    SFX_WIN_LEVEL_3,
    SFX_WIN_LEVEL_4
  ]

  const key = winLevelSounds[level]
  key && Sounds.playSound(key, soundMix[key] || 1)
}

function* onSetCurrentWinIteration(action) {
  const { game } = yield select(state => state)
  const { currentWinData } = game
  const { currentWinIteration } = action
  const winIteration = currentWinData[currentWinIteration]

  const soundKey = (!["H1", "H2", "H3"].includes(winIteration.symbol)) ? SFX_WIN_VALUE_LOW : SFX_WIN_VALUE_HIGH
  Sounds.playSound(soundKey, soundMix.soundKey)
}

function* onCollectScatterSymbol() {
  const { game } = yield select(state => state)

  const { currentFreespins, currentGameMode } = game

  const scatterMeterSounds = [
    SFX_MARS_METER_1,
    SFX_MARS_METER_2,
    SFX_MARS_METER_3,
    SFX_MARS_METER_4,
    SFX_MARS_METER_5
  ]

  if (currentGameMode === GameMode.FREESPIN) {
    const soundKey = scatterMeterSounds[freespinScatters]
    Sounds.playSound(soundKey, soundMix.soundKey)
    if (freespinScatters < scatterMeterSounds.length - 1) {
      freespinScatters += 1
    }
    return
  }

  let scatterMeterKey = scatterMeterSounds[currentFreespins]

  if (currentFreespins) {
    if (currentFreespins >= 5) {
      endMarsAnticipation()
      scatterMeterKey = SFX_MARS_METER_5
    } else if (currentFreespins === 4) {

      Sounds.loopSound(SFX_MARS_METER_LOOP, true)
      Sounds.loopSound(SFX_ROCKET_PREPARE_LOOP, true)

      Sounds.playSound(SFX_LC_IGNITION_START, soundMix.SFX_LC_IGNITION_START)
      Sounds.playSound(SFX_ROCKET_PREPARE, soundMix.SFX_ROCKET_PREPARE)
    }

    Sounds.playSound(scatterMeterKey, soundMix.scatterMeterKey)
  }
}

function endMarsAnticipation() {
  Sounds.fadeOut(SFX_MARS_METER_LOOP, 2000, soundMix.SFX_MARS_METER_LOOP)
}

function onCometFlypast() {
  const passingSounds = [
    SFX_COMET_PASSING_1,
    SFX_COMET_PASSING_2,
    SFX_COMET_PASSING_3,
    SFX_COMET_PASSING_4
  ]

  const flypastSound = getRandomSound(passingSounds)
  Sounds.playSound(flypastSound, soundMix.flypastSound)
}

function onSetRespinSummary() {
  endMarsAnticipation()
  changeMusic(MUSIC_MAIN, 2000, soundMix.music_main)

  Sounds.stopSound(SFX_COMET_LOOP)
  Sounds.playSound(SFX_COMET_DIES, soundMix.SFX_COMET_DIES)
}

function* onStartCountdown() {
  Sounds.stopSound(SFX_COMET_LOOP)

  Sounds.fadeOut(MUSIC_MAIN, 2000, soundMix.MUSIC_MAIN)
  Sounds.playSound(SFX_LC_TMINUS, soundMix.SFX_LC_TMINUS)

  yield gameDelay(3000)
  Sounds.playSound(SFX_LC_COUNTDOWN, soundMix.SFX_LC_COUNTDOWN)

  yield gameDelay(3000)
  yield playRocketLaunch()

  yield gameDelay(500)
  yield put(startBonus())
}

function* playRocketLaunch() {
  Sounds.stopSound(SFX_ROCKET_PREPARE_LOOP)
  Sounds.playSound(SFX_ROCKET_LAUNCH, soundMix.SFX_ROCKET_LAUNCH)

  yield gameDelay(1000)
  Sounds.loopSound(SFX_ROCKET_LOOP, true)
}

function* onStartBonus() {
  yield gameDelay(3000)
  Sounds.playSound(SFX_LC_LIFTOFF, soundMix.SFX_LC_LIFTOFF)
}

function onRocketTakeoffComplete() {
  changeMusic(MUSIC_PICK_MODE, 2000, soundMix.music_pick_mode)
}

function onStartPickStage(action) {
  const { currentPickStageIndex } = action

  changeMusic(MUSIC_PICK_MODE, 2000, soundMix.music_pick_mode)

  if (!currentPickStageIndex) {
    Sounds.fadeIn(SFX_ROCKET_LOOP, 2000)

  } else if (currentPickStageIndex) {
    Sounds.playSound(SFX_ROCKET_STAGE_SEPARATE, soundMix.SFX_ROCKET_STAGE_SEPARATE)
  }
}

function onPickItem() {
  Sounds.playSound(SFX_PICK_STAGE_SELECTION, soundMix.SFX_PICK_STAGE_SELECTION)
}

function onSetCurrentPickResultData(action) {
  const { currentPickResultData } = action
  const latestPick = ArrayHelper(currentPickResultData).last()

  const pick = latestPick.picks.find((element) => {
    return element.picked
  })

  const pickSounds = {
    EXTRA_FUEL: SFX_PICK_STAGE_REVEAL,
    MULTIPLIER: SFX_PICK_STAGE_REVEAL,
    ADD_WILDS: SFX_PICK_STAGE_REVEAL,
    REMOVE_SYMBOL: SFX_PICK_STAGE_REVEAL
  }

  const pickSoundKey = pickSounds[pick.type]

  if (pickSoundKey) {
    Sounds.playSound(pickSoundKey, soundMix.pickSoundKey)
  }

  Sounds.stopSound(SFX_ROCKET_LOOP, soundMix.SFX_ROCKET_LOOP)
  changeMusic(MUSIC_FREESPIN, 2000, soundMix.music_freespin)
}

function onStartSpin() {
  endMarsAnticipation()

  Sounds.stopSound(SFX_COMET_LOOP)
  Sounds.stopSound(SFX_ROCKET_PREPARE_LOOP)

  new Timeout(() => {
    Sounds.loopSound(SFX_REEL_LOOP, true)
  }, 500)
}

function onStartRespin() {
  new Timeout(() => {
    Sounds.loopSound(SFX_REEL_LOOP, true)
  }, 500)
}

function* onStartFreespin() {
  const { game } = yield select(state => state)
  const { currentFreespins } = game

  freespinScatters = 0

  new Timeout(() => {
    Sounds.loopSound(SFX_REEL_LOOP, true)
  }, 500)

  if (currentFreespins < previousFreespins) {
    if (currentFreespins === 1) {
      changeMusic(MUSIC_LAST_CHANCE_1, 2000, soundMix.MUSIC_LAST_CHANCE_1)
    }

    if (currentFreespins === 0) {
      changeMusic(MUSIC_LAST_CHANCE_2, 2000, soundMix.MUSIC_LAST_CHANCE_2)
    }
  } else if (currentFreespins > (previousFreespins + 1)) {
    changeMusic(MUSIC_FREESPIN, 2000, soundMix.music_freespin)
  }

  previousFreespins = currentFreespins
}

function onStartMarsSequence() {
  changeMusic(MUSIC_MARS, 2000, soundMix.music_mars)
}

function onPickLandingZone() {
  Sounds.playSound(SFX_PICK_STAGE_SELECTION, soundMix.SFX_PICK_STAGE_SELECTION)
}

function* onJackpotDraw() {

}

function* onBonusComplete() {
  Sounds.stopSound(SFX_ROCKET_LOOP)

  yield gameDelay(2000)

  changeMusic(MUSIC_MAIN)
}
